export default __webpack_public_path__ + "static/media/solucao-02.4b3262f4.webp";